import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { BASE_API_URL } from "../constants";

const ReferralRedirect = () => {
  const { code } = useParams();

  useEffect(() => {
    fetch(`${BASE_API_URL}/api/referral/resolve/${code}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.redirectUrl) {
          sessionStorage.setItem("referralCode", code);
          window.location.href = data.redirectUrl;
        } else {
          window.location.href = "/explore";
        }
      })
      .catch(() => {
        window.location.href = "/explore";
      });
  }, [code]);

  return <p style={{ textAlign: "center", marginTop: "4rem", color: "#fff" }}>Redirecting...</p>;
};

export default ReferralRedirect;
